class CollectionProductGrid extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productGridWrapper: "[data-product-grid-wrapper]",
      productGrid: "[data-product-grid]",
      productGridList: "[data-product-grid-list]",
      productItem: "[data-product-item]",
      loadMoreButton: "[data-load-more]",
      loadMoreSpinner: "[data-load-more-spinner]",
      paginateCount: "[data-paginate-count]",
    };
    this.productGridWrapper = this.querySelector(
      this.selectors.productGridWrapper
    );
    this.productGrid = this.querySelector(this.selectors.productGrid);

    this.initLoadMore();
  }

  initLoadMore() {
    // Need to use a delegate as the button can be replaced while filtering
    this.addEventListener("click", (event) => {
      if (event.target.hasAttribute("data-load-more")) {
        const nextUrl = this.querySelector(this.selectors.productGrid)?.dataset
          ?.nextUrl;
        if (nextUrl) {
          this.loadMoreProducts(nextUrl);
        }
      } else if (event.target.hasAttribute("data-show-filters")) {
        const button = event.target;
        const active = button.dataset.active;
        button.setAttribute("data-active", active !== "true");

        this.productGridWrapper.classList.toggle(
          "filters-visible",
          active !== "true"
        );
      }
    });
  }

  loadMoreProducts(url) {
    const productGrid = this.querySelector(this.selectors.productGrid);
    const loadMoreButton = this.querySelector(this.selectors.loadMoreButton);
    const loadMoreSpinner = this.querySelector(this.selectors.loadMoreSpinner);
    const paginateCount = this.querySelector(this.selectors.paginateCount);
    loadMoreButton.classList.add("hidden");
    loadMoreSpinner.classList.remove("hidden");

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        loadMoreButton.classList.remove("hidden");
        loadMoreSpinner.classList.add("hidden");

        const productGridNew = parsedHTML.querySelector(
          this.selectors.productGrid
        );
        const paginateCountNew = parsedHTML.querySelector(
          this.selectors.paginateCount
        );
        paginateCount.innerHTML = paginateCountNew.innerHTML;
        const productGridList = this.querySelector(
          this.selectors.productGridList
        );

        const nextProducts = productGridNew.querySelectorAll(
          this.selectors.productItem
        );

        const newUrl = productGridNew.dataset.nextUrl;
        productGrid.setAttribute("data-next-url", newUrl);

        if (newUrl) {
          loadMoreButton.classList.remove("hidden");
        } else {
          loadMoreButton.parentElement.classList.add("hidden");
        }

        nextProducts.forEach((product) => {
          productGridList.appendChild(product);
        });
      });
  }
}

customElements.define("collection-product-grid", CollectionProductGrid);
